/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'

/**
 *
 * @export
 * @interface EnvelopedCategoryUpdateAdmin
 */
export interface EnvelopedCategoryUpdateAdmin {
  /**
   *
   * @type {any}
   * @memberof EnvelopedCategoryUpdateAdmin
   */
  body: any | null
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedCategoryUpdateAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedCategoryUpdateAdmin interface.
 */
export function instanceOfEnvelopedCategoryUpdateAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedCategoryUpdateAdminFromJSON(json: any): EnvelopedCategoryUpdateAdmin {
  return EnvelopedCategoryUpdateAdminFromJSONTyped(json, false)
}

export function EnvelopedCategoryUpdateAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedCategoryUpdateAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: json['body'],
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedCategoryUpdateAdminToJSON(
  value?: EnvelopedCategoryUpdateAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: value.body,
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
